export default {
  name: 'env',
  api: 'http://localhost:9080/backend/',
  backendUrl: 'http://localhost:9080/',
  ospUrl: 'http://localhost:8181/api/',
  googleRecaptcha: '6LcQlIQlAAAAALtOLoiNZkUcdOJJycfJ1ZO68MkB',
  googleKey: 'AIzaSyBZt5tUvyXDjRE4A8h3u2SqhXeDUxqq7As',
  parkingOtaUrl: 'http://localhost:8081'
}
